/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bnb_chain_about = () => `The BNB Chain, formerly known as Binance Smart Chain (BSC), is a blockchain platform introduced by the cryptocurrency exchange Binance. Its native token, BNB, serves various roles within the ecosystem. BNB acts as the network's transaction fuel, similar to gas on Ethereum, and grants users governance rights to participate in on-chain decision-making. In September 2020, Binance introduced the BNB Smart Chain alongside the BNB Beacon Chain, extending BNB's functionality. The BNB Smart Chain supports smart contracts and staking, offering an Ethereum Virtual Machine (EVM)-compatible infrastructure. This dual-chain design aims to provide a high-performance, cost-effective environment for the blockchain community, ensuring compatibility with existing Ethereum tools and dApps while improving scalability and user experience.`
